function BriefingProgress({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) {
  return (
    <div className="w-full bg-gray15 h-[2px]">
      <div
        style={{
          width:
            currentPage === totalPages
              ? "100%"
              : `${((currentPage + 1) / totalPages) * 100}%`,
          transition: "width 0.4s linear",
          height: "100%",
        }}
        className="bg-black"
      ></div>
    </div>
  );
}

export default BriefingProgress;
